import { isDefined, instanceOfReference, I18nService, formatData } from "@perxis-auto/shared";
import { splitCompositeFilterPath } from "../../../../features/filterValues/lib/filterPath/splitCompositeFilterPath.js";
import { APP } from "../../../config/app.js";
import "../../../config/env.js";
import "../../../config/events.js";
const formatSpecification = (vehicleItem, item) => {
  var _a;
  let resultItem = null;
  const { id, key: itemKey, path: itemPath, label, icon, value, formatter } = item;
  const resolvedPath = itemPath ?? itemKey;
  if (!resolvedPath) {
    return resultItem;
  }
  const isMultiple = Array.isArray(resolvedPath);
  const compositePaths = isMultiple ? resolvedPath : [resolvedPath];
  const values = Array(compositePaths.length).fill(null);
  for (let i = 0; i < compositePaths.length; i++) {
    const compositePath = compositePaths[i];
    const { path, field } = splitCompositeFilterPath(compositePath);
    const carFieldValue = (_a = vehicleItem.data) == null ? void 0 : _a[path];
    let resolvedValue = null;
    if (isDefined(value)) {
      resolvedValue = value;
    } else if (Array.isArray(carFieldValue) && instanceOfReference(carFieldValue[0]) || instanceOfReference(carFieldValue)) {
      const extRefs = Array.isArray(carFieldValue) ? carFieldValue : [carFieldValue];
      const extRef = extRefs.find((value2) => {
        if (!field) {
          return true;
        }
        return (value2 == null ? void 0 : value2[field.key]) === field.value;
      });
      if (!extRef) {
        continue;
      }
      resolvedValue = extRef.displayName ?? extRef.name ?? null;
      if ("specification" in extRef) {
        const specificationRef = extRef;
        if (typeof specificationRef.stringValue === "string") {
          resolvedValue ?? (resolvedValue = specificationRef.stringValue);
        } else if (typeof specificationRef.numberValue === "number") {
          resolvedValue ?? (resolvedValue = specificationRef.numberValue);
        } else if (typeof specificationRef.booleanValue === "boolean") {
          resolvedValue ?? (resolvedValue = specificationRef.booleanValue);
        }
      }
    } else if (isDefined(carFieldValue)) {
      resolvedValue = carFieldValue;
    }
    if (typeof resolvedValue === "boolean") {
      const { i18n } = I18nService.getInstance();
      resolvedValue = resolvedValue ? i18n.t("common.booleanValues.trueValue", { ns: APP.name }) : i18n.t("common.booleanValues.falseValue", { ns: APP.name });
    }
    if (!isDefined(resolvedValue)) {
      continue;
    }
    values[i] = resolvedValue;
  }
  if (values.every((value2) => !isDefined(value2))) {
    return resultItem;
  }
  if (!isMultiple) {
    resultItem = {
      id,
      icon,
      label,
      value: formatData(values[0], formatter)
    };
  } else {
    resultItem = { id, icon, label, value: formatData(values, formatter) };
  }
  return resultItem;
};
const formatSpecifications = (vehicleItem, items) => {
  const result = [];
  for (const item of items) {
    const resolvedItem = formatSpecification(vehicleItem, item);
    if (isDefined(resolvedItem)) {
      result.push(resolvedItem);
    }
  }
  return result;
};
export {
  formatSpecification,
  formatSpecifications
};
